export const startupConstants = {
  defaultAppCode: "IM"
};
